import React from 'react';
import styles from './faq.module.scss';
import { partnerrazorpaylogo, partnerkarostartuplogo, partnerdrapperlogo } from 'src/assets/images';
import { FAQList, TFAQList } from './faqlist';

export default function FaqSection() {
    return (
        <section className={styles.faqs}>
            <div className={styles.container}>
                <h3 className={styles.sectionHeading}>Our Partners</h3>
                <div className={styles.supportingPartnerLogo}>
                    <img src={partnerrazorpaylogo} alt="Razorpay" />
                    <img src={partnerkarostartuplogo} alt="KA Startup" />
                    <img src={partnerdrapperlogo} alt="Draper" />
                </div>
                <h2>FAQs</h2>
                {FAQList.map((item: TFAQList, index) => (
                    <div key={index} className={styles.faqItem}>
                        <h5 className={styles.heading}>{item.question}</h5>
                        {!Array.isArray(item?.answer) ? (
                            <p>
                                {item?.answer}
                                {FAQList?.length - 1 === index ? (
                                    <a href="mailto:hello@htraction.com" target="_blank" rel="noopener noreferrer">
                                        hello@htraction.com
                                    </a>
                                ) : null}
                            </p>
                        ) : (
                            <ul className={styles.insideList}>
                                {item.answer.map((answer: string, i: number) => <li key={answer} className={i === item.answer.length - 1 ? styles.last : ""}>{answer}</li>)}
                            </ul>
                        )}
                    </div>
                ))}
            </div>
        </section>
    )
}
